import axios from 'axios';
import apiConfig from '../../api.config';

export default function confirm2fa({ code, sessionUuid }) {
  const {
    host,
    URIs: { confirm2fa },
  } = apiConfig;

  const uri = `${host}${confirm2fa}`;

  return axios
    .post(uri, JSON.stringify({ code, sessionUuid }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => res.status === 200);
}
